export const config = {
  title: "Y&E Cleaning",
  meta: {
    description:
      "Y&E Cleaning offers professional residential and commercial cleaning services in Fitchburg, WI. Reliable, thorough, and eco-friendly solutions.",
    keywords: [
      "Y&E Cleaning",
      "House Cleaning Fitchburg",
      "Commercial Cleaning Wisconsin",
      "Eco-Friendly Cleaning",
      "Fitchburg Cleaning Services"
    ],
    author: "Y&E Cleaning",
    canonicalUrl: "https://jonathan1766.wixstudio.com/yecleaning",
  },
  sections: {
    header: {
      businessName: "Y&E Cleaning",
    },
    sectionB: {
      heroTitle: "Y&E Cleaning",
      heroSubtitle: "Professional Residential & Commercial Cleaning in Fitchburg, WI",
      learnAboutText: "Learn About Our Services",
      phoneNumber: "6085902036",
      phoneLabel: "(608) 590‑2036",
      heroBackgroundImage: "https://media.istockphoto.com/id/1312634996/photo/mopping-the-floor.jpg?s=612x612&w=0&k=20&c=pST_Ay9BtBIOmfFFCHoWdrjx2I1XpQkaGbA70SJJIRA=", 
      cardData: [
        {
          title: "Residential Cleaning",
          description:
            "Thorough cleaning tailored for homes—bedrooms, bathrooms, kitchens, and living areas.",
        },
        {
          title: "Commercial Cleaning",
          description:
            "Reliable office and retail cleaning services to keep your space spotless and professional.",
        },
        {
          title: "Eco-Friendly Products",
          description:
            "We use environmentally-safe products to protect your family and the planet.",
        },
      ],
      description:
        "At Y&E Cleaning, we’re committed to delivering high-quality cleaning services in Fitchburg, WI. Whether it’s your home or your business, you can trust us for dependable, eco-conscious care.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We offer a full range of cleaning solutions for residential and commercial needs.",
      cards: [
        {
          title: "Deep Cleaning",
          description: "Comprehensive cleaning that leaves your space refreshed.",
          imageSrc: "https://media.istockphoto.com/id/1724689214/photo/furniture-deep-cleaning.jpg?s=612x612&w=0&k=20&c=GdrTUquDon2WfoG1aykTJ330Z_BvK9Oew8hZsyAhjpA=",
          imageAlt: "Deep Cleaning",
        },
        {
          title: "Recurring Cleaning",
          description: "Scheduled weekly or bi-weekly visits to keep your space pristine.",
          imageSrc: "https://media.istockphoto.com/id/2083079831/photo/mop-the-floor-every-week-at-least-twice.jpg?s=612x612&w=0&k=20&c=9C1j539xZoD7I1LM1YV8986PjcQMsKdUxktMbUYiTeg=",
          imageAlt: "Recurring Cleaning",
        },
        {
          title: "Move-In/Move-Out",
          description: "Specialized cleaning services for transitions between homes.",
          imageSrc: "https://media.istockphoto.com/id/502117153/photo/moving-day.jpg?s=612x612&w=0&k=20&c=y4kz_epT50BM8V03Z4RzNNDEFoFVjVQO5PqR7IYz8k0=",
          imageAlt: "Move-In Move-Out Cleaning",
        },
      ],
      otherServicesTitle: "Additional Offerings",
      otherServicesList: [
        "Carpet & Floor Care",
        "Window Cleaning",
        "Post-Construction Cleaning",
        "Green Cleaning Options",
        "Custom Cleaning Requests",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://static.wixstatic.com/media/fdb50a_bfced5977fba401486ea2e734e3aee0a~mv2.jpg/v1/fill/w_579,h_388,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_auto/fdb50a_bfced5977fba401486ea2e734e3aee0a~mv2.jpg",
        alt: "Y&E Cleaning Team",
      },
      aboutText: [
        "Y&E Cleaning is a family-owned business serving Fitchburg and surrounding communities with dedication and integrity.",
        "Using eco-friendly cleaning products and a detail-oriented approach, we ensure every space we service feels fresh, clean, and welcoming.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Y&E Cleaning Logo",
      businessName: "Y&E Cleaning",
      contact: {
        phone: "6085902036",
        phoneLabel: "(608) 590‑2036",
        email: "esperanzaperezgarcia123@gmail.com",
        website: "https://jonathan1766.wixstudio.com/yecleaning",
        address: "6095 Viroqua Dr, Fitchburg, WI 53719",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "6095 Viroqua Dr, Fitchburg, WI 53719",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2943.123456789!2d-89.4123456!3d43.0395678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88062b123456789ab%3A0xabcdef1234567890!2s6095%20Viroqua%20Dr%2C%20Fitchburg%2C%20WI%2053719!5e0!3m2!1sen!2sus!4v1718579999999!5m2!1sen!2sus",
    },
  },
};

export default config;
